// ERP 松木
<template>
    <div class="enterprise">
        <div class="one1">
            <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back3.png" alt="">
            <div class="one1_content">
                <div class="title_name title_name_one">德木云</div>
                <div class="title_name title_name_two">让木材企业管理更加简单</div>
            </div>
        </div>
        <div class="one2 content">
            <div class="homeTitle">
                <div class="name">主要产品</div>
            </div>
            <div class="explain">MAIN PRODUCTS</div>
            <div class="titmeName">
                <div class="title">木贸经营流程全覆盖</div>
                <div class="explainTitle">高效的业务、财务、提货、物流、融资、数据一体化解决方案</div>
            </div>
            <div class="enterprise_one2 enterprise_content">
                <div class="item wow animate__animated animate__fadeInUpBig" data-wow-duration ="0.6s" data-wow-delay ="0.4s" v-for="(item,index) in one2List" :key="index">
                    <div class="item_content">
                        <img :src="item.icon" alt="">
                        <div class="name">{{item.name}}</div>
                        <div class="explain">{{item.explain}}</div>
                    </div>
                </div>
            </div>
        </div>
        <template v-for="(item,index) in erpList">
            <div :key="index+'_erp'">
                <div v-if="(index+1)%2 !=0" class="content one3">
                    <div class="one3_content enterprise_content">
                        <div class="left wow animate__animated animate__bounceInLeft" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="right">
                            <div class="item_list_content">
                                <div class="title">{{item.title}}</div>
                                <div class="explain">{{item.explain}}</div>
                                <div class="item_bottom">
                                    <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                                    <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="one4 content">
                    <div class="one4_content enterprise_content">
                        <div class="left">
                            <div class="item_list_content">
                                <div class="title">{{item.title}}</div>
                                <div class="explain">{{item.explain}}</div>
                                <div class="item_bottom">
                                    <div class="ontrial"><img src="../../../../public/images/free.png" alt=""> 免费试用</div>
                                    <div class="consult"><img class="be" src="../../../../public/images/consult.png" alt=""><img class="be_wh" src="../../../../public/images/consult_wh.png" alt=""> 详情咨询</div>
                                </div>
                            </div>
                        </div>
                        <div class="right wow animate__animated animate__bounceInRight" data-wow-duration ="0.6s" data-wow-delay ="0.4s">
                            <img :src="item.icon" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {},
    data(){
        return{
            one2List:[
                {
                    name:'采购环节',
                    explain:'合同管控，结算灵活',
                    icon:require('@/assets/icon/2.png'),
                },
                {
                    name:'销售环节',
                    explain:'开单高效，跟进方便',
                    icon:require('@/assets/icon/21.png'),
                },
                {
                    name:'财务环节',
                    explain:'业财一体，收付清晰',
                    icon:require('@/assets/icon/1.png'),
                },
                {
                    name:'库存环节',
                    explain:'库存锁货，管理省心',
                    icon:require('@/assets/icon/13.png'),
                },
                {
                    name:'提货环节',
                    explain:'在线协同，流程客观',
                    icon:require('@/assets/icon/18.png'),
                },
                {
                    name:'融资环节',
                    explain:'快速融资、便捷赎货',
                    icon:require('@/assets/icon/16.png'),
                },
                {
                    name:'客户环节',
                    explain:'客户分析、实时掌控',
                    icon:require('@/assets/icon/12.png'),
                },
                {
                    name:'企业报表',
                    explain:'报表分析、轻松管控',
                    icon:require('@/assets/icon/15.png'),
                },
                {
                    name:'行业数据',
                    explain:'数据赋能、采销决策',
                    icon:require('@/assets/icon/17.png'),
                },
                {
                    name:'风控预警',
                    explain:'实时预警、风险可控',
                    icon:require('@/assets/icon/9.png'),
                },
            ],
            erpList:[
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/1.png',
                    title:'采购跟踪，合同执行更高效',
                    explain:'国外货物采购基于合同管理精准跟踪钱、货、票的动向，相关采购 成本费，开证费、包干费、税金实时录入，采购成本准确无误',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/2.png',
                    title:'销售管理，便捷开单实装数据自动同步',
                    explain:'PC+手机小程序随时随地开单销售，实装明细与销售不符时无需改单 ，系统自动同步到销售单和财务应收，销售金额准确无误，销售即锁 货，避免多人重卖',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/3.png',
                    title:'库存管理，ERP和仓库WMS系统数据同步',
                    explain:'库存数据由仓库录入实时同步到ERP，无需自己录入减少人力成本， 仓库进出货物实时更新同步，库存分析、库龄分析、成本查看，让 库存管理变得很简单',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/4.png',
                    title:'财务应收，让你的应收账款一分不会少',
                    explain:'系统自动生成应收账单，客户付款实时结算，客户未付标记欠款，预计收汇日超时提醒 显示超期天数，款到放行，安全高效',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/5.png',
                    title:'提货管理，系统自动生成提单一键提交',
                    explain:'库存数据由仓库录入实时同步到ERP，无需自己录入减少人力成本， 仓库ERP对接仓库WMS系统，ERP自动生成提货单，多仓库或多开证 公司也会自动分裂成多个提单，在线提货智能协同，提货装车全流 程可视化，无需专门库管负责，降本增效',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/6.png',
                    title:'融资管理，在线融资，随借随还',
                    explain:'ERP接入在线金融入口，实现融资在线化，分为“现货融”、“代赎货”、 “订单融”，操作简单，融资快，利率低，赎货便捷，解决贸易商融 资难、融资贵的难题',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/7.png',
                    title:'CRM客户管理，系统辅助，轻松掌控',
                    explain:'销售工作台每天自动帮助业务员梳理客户维护沟通情况，显示多少 天未联系，通过报表和图表让老板对公司所销售的工作情况及客户 的维护情况一目了然，实现轻松精细化管理客户',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/8.png',
                    title:'企业报表，用实时数据展现真实的 企业经营的状况',
                    explain:'企业数字化管理，老板将能实时了解企业运营状况，采购、销售、 库存、客户自动生成统计业务报表，提升公司整体决策能力',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/9.png',
                    title:'行业数据，大数据赋能决策采销更可靠',
                    explain:'在途资源、现货库存、仓库实时进出等大数据，赋能用户科学决策， 实时研判市场动向，合理制定采销策略',
                },
                {
                    icon:'https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/erp/10.png',
                    title:'风控预警，电脑辅助人脑更轻松',
                    explain:'库存、库龄、应收、应付实时预警，让系统时刻提醒关键节点 ，降低人为失误率',
                }
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{

    }
}
</script>

<style scoped  lang="scss">
    .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
    .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
    .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
    .explain{text-align: center;color: #999999;}
    .homeContent{max-width: 120rem;margin: 0 auto;padding: 3rem 1rem;}
    .titmeName{text-align: center;margin: 1rem 0 0 0;}
    .titmeName .title{color: #333;font-weight: 600;font-size: 2.4rem;margin-bottom: 0.5rem;}
    .titmeName .explainTitle{color: #999999;font-weight: 600;font-size: 1.4rem;line-height: 2rem;}
    .one1{
        width: 100%;height: 50rem;
        position: relative;
        .icon{
            height: 100%;width: 100%;
        }
        .one1_content{
            width: 104rem;height: 65%;
            padding: 2rem 8rem;
            position: absolute;left: 50%;bottom: 0;transform: translateX(-50%); z-index: 2;
            border-top-left-radius: 0.6rem;
            border-top-right-radius: 0.6rem;
            color: #fff;
            .title_name{
                font-size: 4rem;
            }
            .title_name_one{text-indent: 10rem;font-weight: 500;}
            .title_name_two{text-indent: 10rem;font-size: 2.5rem;margin-top: 8rem;}
            .title_list{font-size: 1.4rem;}
            .title_list li{margin-top: 1rem;}
        }
    }
    .enterprise{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
    .enterprise .content{width: 100%;}
    .enterprise_content{width: 120rem;margin: 0 auto;}
    .enterprise_one2{display: flex;flex-wrap: wrap;margin-top: 3rem;}
    .enterprise_one2 .item{width: 24rem;
        .item_content{border: 0.1rem solid #ddd;margin:0 -0.1rem -0.1rem 0;padding: 3rem 0; display: flex;flex-direction: column;align-items: center;
            font-size: 1.4rem;
            >img{width: 5rem;height: 5rem;}
            .name{margin-top: 1rem;}
            .explain{color: #5D5D5D;}
        }
        .item_content:hover{box-shadow: 3px 3px 15px rgba(51, 51, 51, 0.1);cursor: pointer;border-top-color: #409EFF;}
    }

    .one3{margin-top: 3rem;
        .one3_content{
            background: #F5F6FA;
            height: 40rem;
            display: flex;
            .left{height: 100%;display: flex;align-items: center;flex: 1;padding-left: 2rem;}
            .right{height: 100%;flex: 1;display: flex;align-items: center;justify-content: center;}
        }
    }
    .one4{margin-top: 3rem;
        .one4_content{
            height: 40rem;
            display: flex;
            .left{height: 100%;display: flex;align-items: center;flex: 1;}
            .right{height: 100%;display: flex;align-items: center;flex: 1;padding-right: 2rem;}
        }
    }
    .item_list_content{
        padding: 0 10rem;
        text-align: left;
        .title{font-size: 2.2rem;}
        .explain{font-size: 1.4rem;color: #333;text-align: left;margin: 2rem 0;}
    }
</style>